(function() {
    'use strict';

    angular
        .module('elogbooks.common.assets')
        .controller('UserAssetsHistoricalScoresController', UserAssetsHistoricalScoresController);

    UserAssetsHistoricalScoresController.$inject = [
        'historicalScoresCollectionResponse',
        'assetScoreTypesResponse',
        'assetResponse',
        '$state',
        '$stateParams',
        'paramConverterService',
        '$translate'
    ];
    function UserAssetsHistoricalScoresController(
        historicalScoresCollectionResponse,
        assetScoreTypesResponse,
        assetResponse,
        $state,
        $stateParams,
        paramConverterService,
        $translate
        ) {
        var vm = this;
        vm.historicalScoresCollection = historicalScoresCollectionResponse;
        vm.historicalScores = historicalScoresCollectionResponse.historicalScores;
        vm.hasSubAssets = assetResponse.hasSubAssets && !$stateParams.subAssetId;
        vm.search = searchAction;
        vm.order = orderAction;
        vm.scoreTypeOptions = paramConverterService.formatResponse(assetScoreTypesResponse.scoreTypes);

        vm.criteria = {
            dateRange: {
                type: 'date-range',
                title: 'BETWEEN_DATES',
                endMaxDate: moment(),
                value: {
                    startDate: ($stateParams.dateRange !== null && typeof $stateParams.dateRange === 'string') ? moment(new Date($stateParams.dateRange.split(',')[0])) : null,
                    endDate: ($stateParams.dateRange !== null && typeof $stateParams.dateRange === 'string') ? moment(new Date($stateParams.dateRange.split(',')[1])) : null
                },
                clearValue: {
                    startDate: null,
                    endDate: null
                }
            },
            assetScoreType: {
                type: 'options',
                title: 'ASSET_SCORE_TYPE',
                value: JSON.parse($stateParams.assetScoreType),
                options:vm.scoreTypeOptions
            },
            subAssetActive: {
                type: 'options',
                title: 'SUB_ASSET_STATUS',
                value: $stateParams.subAssetActive,
                options: [
                    {title: $translate.instant('NONE_SELECTED'), value: 'all'},
                    {title: $translate.instant('STATUS_ACTIVE'), value: '1'},
                    {title: $translate.instant('STATUS_INACTIVE'), value: '0'}
                ],
            }
        };

        function searchAction(params) {
            var override = {
                historicalScorePage: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }

        function orderAction(key) {
            var override = {
                historicalScorePage: 1,
                historicalScoreOrder: key
            };

            $state.go('.', angular.extend({}, $stateParams, override), { reload: $state.current });
        }
    }
})();
